import React, { Fragment, useEffect, useState } from "react";
import { Col, Card, CardHeader, Table, Form, FormGroup, Label, Input, ModalFooter, Row, } from "reactstrap";
import { Btn } from "../../AbstractElements";
import { useDispatch, useSelector } from "react-redux";
import CommonModal from "../../Components/Modals/modal";
import Pagination from "../../Components/Pagination/Pagination";
import Empty from "../../Components/Empty/Index";
import SweetAlert from "sweetalert2";

import { getTeachers, ModalToggle, isOpenModal, addTeachers, updateTeachers, deleteTeacher, } from "../../store/teachersSlice";
import moment from "moment";
import TeacherHoursModal from "./TeacherHoursModal";


const TeachersTable = () => {
  const storeVar = useSelector((state) => state.teachers);
  const dispatch = useDispatch();
  const toggle = () => dispatch(ModalToggle());
  const [submit, setSubmit] = useState(false);
  const [togglePassword, setTogglePassword] = useState(false);
  const [hoursModal, setHoursModal] = useState({ open: false, teacher: null });
  const openHoursModal = (teacher) => setHoursModal({ open: true, teacher });
  const closeHoursModal = () => setHoursModal({ open: false, teacher: null });


  const [formVar, setFormVar] = useState({
    keyword: "",
    limit: 30,
    offset: 0,
    currentPage: 1,
    status: "active",
    modalTitle: null,
    editState: false,
    teacherId: "",
    name: "",
    email: "",
    phoneNumber: "",
    password: "",
    subject: "",
  });

  useEffect(() => {
    dispatch(getTeachers(formVar.limit, formVar.offset, formVar.status));
  }, []);

  const pageChange = (page) => {
    const offset = formVar.limit * (page - 1);
    setFormVar((prevFormVar) => ({
      ...prevFormVar,
      currentPage: page,
      offset: offset,
    }));
    dispatch(getTeachers(formVar.limit, offset, formVar.status));
  };
  const EditToggleModal = (data) => {
    dispatch(isOpenModal(true));
    setFormVar((prevFormVar) => ({
      ...prevFormVar,
      editState: true,
      teacherId: data._id,
      modalTitle: "Edit Teachers",
      name: data.name,
      email: data.email,
      phoneNumber: data.phoneNumber,
      password: "",
      subject: data.subject,

    }));
  };
  const AddToggleModal = () => {
    dispatch(isOpenModal(true));
    setFormVar((prevFormVar) => ({
      ...prevFormVar,
      editState: false,
      modalTitle: "Add Teachers",
      name: "",
      email: "",
      phoneNumber: "",
      password: "",
    }));
  };
  const submitMenu = () => {
    if (nameValid() || emailValid() || phoneNumberValid() || (!formVar.editState && passwordValid() || subjectValid())
    ) {
      setSubmit(true);
      return null;
    }
    setSubmit(false);
    if (formVar.editState) {
      dispatch(
        updateTeachers(formVar.teacherId, {
          name: formVar.name,
          email: formVar.email,
          phoneNumber: formVar.phoneNumber,
          password: formVar.password,
          subject: formVar.subject,
        })
      );
    } else {
      dispatch(
        addTeachers({
          name: formVar.name,
          email: formVar.email,
          phoneNumber: formVar.phoneNumber,
          password: formVar.password,
          subject: formVar.subject,
        })
      );
    }
  };

  const nameValid = () => {
    if (!formVar.name) {
      return "Name is required";
    }
  };
  const emailValid = () => {
    if (!formVar.email) {
      return "Email is required";
    }
  };
  const phoneNumberValid = () => {
    if (!formVar.phoneNumber) {
      return "Phone Number is required";
    }
  };
  const passwordValid = () => {
    if (!formVar.password && !formVar.editState) {
      return "Password is required";
    }
  };
  const subjectValid = () => {
    if (!formVar.subject) {
      return "Subject is required";
    }
  };

  const DeleteModel = (data) => {
    SweetAlert.fire({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Ok",
      cancelButtonText: "Cancel",
      reverseButtons: true,
    }).then((result) => {
      if (result.value) {
        dispatch(deleteTeacher(data._id));
      }
    });
  };
  const getDateTime = (date) => {
  if (date) {
    return moment(date).format("DD MMM YYYY hh:mm A");
  }
};

  return (
    <Fragment>
      <Col sm="12">
        <Card>
          <CardHeader>
            <Row>
              <Col md="6"></Col>
              <Col md="4"></Col>
              <Col
                md="2"
                className="d-flex justify-content-end align-items-center"
              >
                <div className="text-end border-2 w-100">
                  <Btn
                    attrBtn={{
                      color: "info-gradien",
                      className: "w-100",
                      size: "sm",
                      onClick: AddToggleModal,
                    }}
                  >
                    Add Teachers
                  </Btn>
                </div>
              </Col>
            </Row>
          </CardHeader>
          <div className="table-responsive">
            <Table hover={true} className="table-border-horizontal table-light">
              <thead>
                <tr>
                  <th scope="col">Sl.No</th>
                  <th scope="col">Name</th>
                  <th scope="col">Subject</th>
                  <th scope="col">Phone Number</th>
                  <th scope="col">Email</th>
                  <th scope="col">Created At</th>
                  <th scope="col">Action</th>
                </tr>
              </thead>
              <tbody>
                {storeVar.teachersData?.map((item, index) => (
                  <tr key={index}>
                    <th scope="row">{index + 1}</th>
                    <td>{item.name}</td>
                    <td>{item.subject}</td>
                    <td>{item.phoneNumber}</td>
                    <td>{item.email}</td>
                    <td>{getDateTime(item.createdAt)}</td>
                    <td>
                      <div className="d-flex gap-2 align-items-center">
                        <div className="cursor-pointer bg-light-primary font-primary action-icon">
                          <i
                            className="fa fa-edit fa-lg"
                            onClick={(e) => EditToggleModal(item)}
                          ></i>
                          <div className="tooltipCustom">Edit</div>
                        </div>
                        <div
                          className="cursor-pointer bg-light-warning font-warning action-icon"
                          onClick={() => openHoursModal(item)}
                        >
                          <i className="fa fa-clock-o fa-lg"></i>
                          <div className="tooltipCustom">Class Hours</div>
                        </div>
                        <div className="cursor-pointer bg-light-info font-danger action-icon">
                          <i
                            className="fa fa-trash fa-lg"
                            onClick={(e) => DeleteModel(item)}
                          ></i>
                          <div className="tooltipCustom">Delete</div>
                        </div>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
          {storeVar.totalTeachers <= 0 && <Empty />}
        </Card>
        {storeVar.totalTeachers > 0 && (
          <Pagination
            currentPage={formVar.currentPage}
            totalItem={storeVar.totalTeachers}
            itemsPerPage={formVar.limit}
            showEllipsisAfter={true}
            visiblePageCount={3}
            onPageChange={pageChange}
          />
        )}
      </Col>
      <CommonModal
        isOpen={storeVar.isOpenModal}
        title={formVar.modalTitle}
        toggler={toggle}
        size={"xl"}
      >
        <Form autoComplete="off">
          <FormGroup className="position-relative">
            <Row>
              <Col md={6}>
                <Label className="col-form-label" for="recipient-name">                  Name                </Label>
                <Input
                  className="form-control"
                  type="text"
                  placeholder="Enter Name"
                  onChange={(e) => setFormVar((prevFormVar) => ({ ...prevFormVar, name: e.target.value, }))}
                  value={formVar.name}
                  autoComplete="false"
                />
                {submit && nameValid() ? (<span className="d-block font-danger">{nameValid()}</span>) : ("")}
              </Col>
              <Col md={6}>
                <Label className="col-form-label" for="recipient-name">
                  Email
                </Label>
                <Input
                  className="form-control"
                  type="email"
                  placeholder="Enter Email"
                  onChange={(e) =>
                    setFormVar((prevFormVar) => ({
                      ...prevFormVar,
                      email: e.target.value,
                    }))
                  }
                  value={formVar.email}
                  autoComplete="false"
                />
                {submit && emailValid() ? (
                  <span className="d-block font-danger">{emailValid()}</span>
                ) : (
                  ""
                )}
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <Label className="col-form-label" for="recipient-name">
                  Phone Number
                </Label>
                <Input
                  className="form-control"
                  type="number"
                  placeholder="Enter Phone Number"
                  onChange={(e) =>
                    setFormVar((prevFormVar) => ({
                      ...prevFormVar,
                      phoneNumber: e.target.value,
                    }))
                  }
                  value={formVar.phoneNumber}
                  autoComplete="false"
                />
                {submit && phoneNumberValid() ? (
                  <span className="d-block font-danger">
                    {phoneNumberValid()}
                  </span>
                ) : (
                  ""
                )}
              </Col>
              <Col md={6}>
                <Label className="col-form-label" for="recipient-name">
                  Password
                </Label>
                <div className="position-relative">
                  <Input
                    className="form-control"
                    type={togglePassword ? "text" : "password"}
                    placeholder="Enter password"
                    onChange={(e) =>
                      setFormVar((prevFormVar) => ({
                        ...prevFormVar,
                        password: e.target.value,
                      }))
                    }
                    value={formVar.password}
                    autoComplete="false"
                  />
                  <div
                    className="show-hide"
                    onClick={() => setTogglePassword(!togglePassword)}
                    style={{ top: "50%" }}
                  >
                    <span className={togglePassword ? "" : "show"}></span>
                  </div>
                </div>
                {submit && passwordValid() ? (
                  <span className="d-block font-danger">{passwordValid()}</span>
                ) : (
                  ""
                )}
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <Label className="col-form-label" for="recipient-name">Subject</Label>
                <Input
                  className="form-control"
                  type="text"
                  placeholder="Enter Subject"
                  onChange={(e) => setFormVar((prevFormVar) => ({ ...prevFormVar, subject: e.target.value, }))}
                  value={formVar.subject}
                  autoComplete="false"
                />
                {submit && subjectValid() ? (<span className="d-block font-danger">{subjectValid()}</span>) : ("")}
              </Col>
            </Row>
          </FormGroup>
        </Form>
        <ModalFooter>
          <Btn attrBtn={{ color: "secondary", onClick: toggle }}>Close</Btn>
          <Btn attrBtn={{ color: "primary", onClick: submitMenu }}>
            Save Changes
          </Btn>
        </ModalFooter>
      </CommonModal>

      <TeacherHoursModal
        isOpen={hoursModal.open}
        toggle={closeHoursModal}
        teacher={hoursModal.teacher}
      />
    </Fragment>
  );
};

export default TeachersTable;
